import React, {useState} from "react";
import html from "react-inner-html";
import Aux from "../../../../hoc/Auxiliary/Auxiliary";
import SpellChecker from "../../../UI/SpellChecker/SpellChecker";
import {translation} from "../../../../I18n/i18n";

const TechnicalSkills = (props) => {
    const [technicalSkills, setTechnicalSkills] = useState (props.element.Description._text);

    return (
        props.hasWriteAccess ? <SpellChecker freeTextBox
                                             dict={ props.dict }
                                             notify={ props.notify }
                                             addToDictionary={ props.addToDictionary }
                                             lang={ props.lang }
                                             onChange={ v => {
                                                 setTechnicalSkills (v)
                                                 props.element.Description._text = v
                                             } }
                                             placeholder={ `${ translation (props.lang, "Technical Skills") } ...` }
                                             value={ technicalSkills }
            />
            : <Aux>
                <br/>
                <div { ...html (props.element.Description._text) } />
            </Aux>
    )
};

export default TechnicalSkills;
